import { Tabs } from '@mantine/core';
import TabsList from '@repo/common/components/TabsList';
import { useState } from 'react';
import {
	useSuspenseFeatureAccess,
	type IIntegration,
} from '../../../../../api';
import { SyncType } from '../../../../../interfaces/Enums';
import type { IntegrationSpec } from '../../../../../interfaces/IntegrationSpec';
import { ScheduleInput } from './ScheduleInput';

interface SchedulePanelProps {
	integration: IIntegration;
	spec: IntegrationSpec;
}

export function SchedulePanel({ integration, spec }: SchedulePanelProps) {
	const [activeTab, setActiveTab] = useState<string | null>(SyncType.PULL);
	const { secodaCoreAccess } = useSuspenseFeatureAccess();

	const pullEnabled = !spec.value.disablePullMetadata;
	const pushEnabled = spec.value.supportsPushMetadata && secodaCoreAccess;

	if (pullEnabled && pushEnabled) {
		return (
			<Tabs
				color="dark"
				defaultValue={SyncType.PULL}
				value={activeTab}
				onTabChange={setActiveTab}
				keepMounted={false}
			>
				<TabsList
					tabs={[
						{ value: SyncType.PULL, label: 'Pull' },
						{ value: SyncType.PUSH, label: 'Push' },
					]}
				/>

				<Tabs.Panel value={SyncType.PULL} pt="2xl">
					<ScheduleInput integration={integration} type={SyncType.PULL} />
				</Tabs.Panel>

				<Tabs.Panel value={SyncType.PUSH} pt="2xl">
					<ScheduleInput integration={integration} type={SyncType.PUSH} />
				</Tabs.Panel>
			</Tabs>
		);
	}

	if (pushEnabled) {
		return <ScheduleInput integration={integration} type={SyncType.PUSH} />;
	}

	if (pullEnabled) {
		return <ScheduleInput integration={integration} type={SyncType.PULL} />;
	}

	return null;
}
